import { Controller as BaseController } from "@hotwired/stimulus";

export class Controller extends BaseController {
  static targets = ["field", "input"];

  connect() {
    this.toggle();
  }

  toggle() {
    if (this.inputTarget.checked) {
      this.fieldTarget.classList.remove("hidden");
    } else {
      this.fieldTarget.classList.add("hidden");
    }
  }
}
